<script lang="ts">
	import Icon from "svelte-awesome";
	import { github } from "svelte-awesome/icons";
</script>

<a href="https://github.com/starptr" target="_blank">
	<Icon data={github} scale="2" inverse={false} style="color: #333" />
</a>

<style lang="scss">
	a {
		margin-right: 0.5em;
		margin-left: 0.5em;
	}
</style>
